<template>
    <div class="row no-gutters matchrequest-form">
        <div :class="[player2 ? 'col-12' : 'col-12',]">
            <div class="card">
                <div class="card-header p-xl-2 p-1">
                    <h3 class="float-left">{{ __("matchform.new_request") }}</h3>
                    <a href="/matchrequests" class="btn btn-danger float-right" v-if="this.appmode == 'online'">
                        {{__("matchform.cancel")}}
                    </a>
                </div>
                <div class="card-body matchrequest-card-body">
                    <div class="mainform">
                        <div id="matchtype_selection" class="d-flex" v-if="step == 1">
                            <div :class="['matchtype_button',mtype.id == selectedMatchType.id ? 'active' : '',]" @click="matchtypeSelect(mtype.id)" v-for="mtype in matchtypes" v-bind:key="mtype.id">
                                <div class="matchtype_name">{{ mtype.name }}</div>
                                <div class="matchtype_status">{{mtype.beta ? "Beta" : ''}}</div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="matchtype_button active" @click="gotoStep(1)">{{selectedMatchType.name}}</div>
                        </div>

                        <div id="matchtype_options" v-if="selectedMatchType != null && step == 2">
                            <h3 v-if="selectedMatchType.options &&selectedMatchType.options.length > 0">{{ __("matchform.game_options") }}</h3>
                            <div class="optionSelector gridSelector" v-for="option in selectedMatchType.options" v-bind:key="option.name">
                                <h4>{{ __(option.name) }}</h4>
                                <div class="optionSelectorOptions">
                                    <div class="optionSelectorContainer" v-if="option.range">
                                        <a href="#" class="options_button range_button" @click.prevent="optionsRangeSelect(option.name, -1)">-</a>
                                        <div class="options_button range_button_number">
                                            <input type="text" v-model="option.selected" class="rangeselectOption"></div>
                                        <a href="#" class="options_button range_button" @click.prevent="optionsRangeSelect(option.name, 1)">+</a>
                                    </div>
                                    <div v-else :class="['options_button',option.selected == o ? 'active' : '',]" @click="optionSelect(option.name, o)" v-for="o in option.options" v-bind:key="o">{{ __(o) }}</div>
                                </div>
                            </div>
                        </div>
                        <div v-else-if="step == 3">
                            <div class="selectedMatchtypeOptions">
                                <div class="options_button" v-for="e in step2selectedOptions" v-bind:key="e.id" @click="gotoStep(2)">{{__(e.label)}}: {{__(e.value)}}</div>
                            </div>
                        </div>
                        <div id="global_options" v-if="step == 3">
                            <div class="automat_options" v-if="appmode == 'automat'">
                                <h3>{{__("matchform.automat_players")}}</h3>
                                <div class="row">
                                    <div :class="['', option.class ? option.class : 'col-12']" v-for="option in automatOptions" v-bind:key="option.name">
                                        <div class="optionSelector gridSelector" v-if="option.id != 'automat_cpu_players' || selectedMatchType.name == 'X01'">
                                            <h4>{{ __(option.name) }}</h4>
                                            <div class="optionSelectorOptions">
                                                <div :class="['options_button',option.selected == o ? 'active' : '',]" @click="optionSelectAutomat(option.name, o)" v-for="o in option.options" v-bind:key="o">{{ __(o) }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col"><h3>{{ __("matchform.global_options") }}</h3></div>
                                <div class="col text-right" v-if="appmode == 'online'"><a href="#" class="options_button" @click="toggleShowOnlineOptions">Zeige/Verstecke Online Optionen</a></div>
                            </div>
                            <div v-if="selectedMatchType.id != null">
                                <div class="row">
                                    <template v-for="option in globalOptions">
                                    <div :class="['', option.class ? option.class : 'col-12']" v-bind:key="option.name"  v-if="option.onlineOption ? (showOnlineOptions ? true : false) : true">
                                        <template>
                                            <div class="optionSelector gridSelector">
                                                <h4>{{ option.name }}</h4>
                                                <div class="optionSelectorOptions">
                                                    <template v-if="!option.denyChange">
                                                        <div class="optionSelectorContainer" v-if="option.range">
                                                            <a href="#" class="options_button range_button" @click.prevent="optionsRangeSelect(option.name, -1)">-</a>
                                                            <div class="options_button range_button_number">{{ option.selected }}</div>
                                                            <a href="#" class="options_button range_button" @click.prevent="optionsRangeSelect(option.name, 1)">+</a>
                                                        </div>
                                                        <div v-else :class="['options_button',option.selected == o ? 'active' : '',]" @click="optionSelectGlobal(option.name, o)" v-for="o in option.options" v-bind:key="o">{{ o }}</div>
                                                    </template>
                                                    <template v-else>
                                                        <div class="options_button range_button_number">
                                                            {{option.selected}}
                                                        </div>
                                                    </template>
                                                </div>
                                                <div class="options-descriptions-toggle" v-if="option.description">
                                                    <a href="#" @click="toggleShowTip(option.id)"><i class="fas fa-info-circle"></i></a>
                                                </div>
                                                <div v-if="option.description && showTip[option.id]" class="text-sm grid-description" v-html="option.description"></div>

                                                <template v-if="option.name == 'Ligaspiel2'">
                                                    <div class="league_options" v-if="leaguegame">
                                                        <div class="input-group mb-1">
                                                            <div class="input-group-prepend">
                                                                <label class="input-group-text" for="inputGroupSelect01">{{ __("matchform.choose_league") }}</label>
                                                            </div>
                                                            <select class="custom-select" id="inputGroupSelect01" @change="onSelectLeague()" v-model="league">
                                                                <option :value="lea.id" v-for="lea in leagues" :key="lea.id">{{ lea.name }}</option>
                                                            </select>
                                                        </div>
                                                        <div class="input-group">
                                                            <div class="input-group-prepend">
                                                                <label class="input-group-text" for="inputGroupSelect02">{{ __("matchform.choose_opponent") }}</label>
                                                            </div>
                                                            <select class="custom-select" id="inputGroupSelect02" v-model="league_opponent">
                                                                <option :value="opponent.id" v-for="opponent in league_opponents" :key="opponent.id">{{ opponent.name }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </template>
                                                <template v-if="option.name == 'Ligaspiel'">
                                                    <div class="league_options" v-if="leaguegame">
                                                        <div class="d-flex mt-2 align-items-end">
                                                            <h5>{{ __("matchform.choose_league") }}</h5>
                                                            <div class="div flex-fill ml-4">
                                                                <select class="custom-select" id="inputGroupSelect01" @change="onSelectLeague()" v-model="league">
                                                                    <option :value="lea.id" v-for="lea in leagues" :key="lea.id">{{ lea.name }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div class="d-flex mt-2 align-items-end">
                                                            <h5>{{ __("matchform.choose_opponent") }}</h5>
                                                            <div class="div flex-fill ml-4">
                                                                <select class="custom-select" id="inputGroupSelect02" v-model="league_opponent">
                                                                    <option :value="opponent.id" v-for="opponent in league_opponents" :key="opponent.id">{{ opponent.name }}</option>
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </template>
                                    </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="submit mt-3 d-flex" v-if="selectedMatchType.id != null">
                            <a href="#" class="btn btn-secondary stepButton prevButton" @click="previousStep()" v-if="step != 1">
                                <i class="fas fa-arrow-circle-left"></i>
                                {{ __("matchform.previous_step") }}
                            </a>
                            <a href="#" class="btn btn-primary stepButton" @click="nextStep()" v-if="step != 3">
                                <i class="fas fa-arrow-circle-right"></i>
                                {{ __("matchform.next_step") }}
                            </a>
                            <a href="#" class="btn btn-primary stepButton" @click="submit()" v-if="step == 3 && this.appmode == 'online'">
                                <i class="fas fa-plus-square"></i>
                                {{ __("matchform.next_step") }}
                            </a>
                            <a href="#" class="btn btn-primary stepButton" @click="submit()" v-if="step == 3 && this.appmode == 'automat'">
                                <i class="fas fa-plus-square"></i>
                                {{ __("matchform.start_game") }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-2 pl-xl-2 col-12" v-if="player2">
            <div class="card mb-2">
                <div class="card-header">{{ __("matchform.opponent") }}</div>
                <div class="card-body">{{ __("matchform.opponent_name") }}: {{ player2.player.name }}</div>
            </div>

            <div class="card">
                <div class="card-header">{{ __("matchform.datetime") }}</div>
                <div class="card-body">
                    <input type="radio" v-model="setmeeting" id="setmeetingbutton1" value="false" checked />
                    <label for="setmeetingbutton1">{{ __("matchform.no_datetime") }}</label>
                    <br />
                    <input type="radio" v-model="setmeeting" id="setmeetingbutton2" value="true" />
                    <label for="setmeetingbutton2">{{ __("matchform.special_datetime") }}:</label>
                    <vc-date-picker v-model="date" mode="dateTime" :timezone="timezone" is24hr locale="de" :minute-increment="5" color="red" is-expanded v-if="setmeeting == 'true'" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import matchtypesJSON from '@/matchtypes.json'
export default {
    props: ["player2", "appmode"],
    data() {
        return {
            matchtypes: matchtypesJSON.matchtypes,
            globalOptions: [
                {
                    id: "legs",
                    name: __("matchform.legs_amount"),
                    range: [1, 27],
                    selected: 1,
                    class: "col-xl-6 col-12",
                    denyChange: false,
                },
                {
                    id: "sets",
                    name: __("matchform.sets_amount"),
                    range: [1, 5],
                    selected: 1,
                    class: "col-xl-6 col-12",
                    denyChange: false,
                },
                {
                    id: "starting_firstleg",
                    name: __("matchform.start_first_leg"),
                    class: "col-xl-6 col-12 bg-darker",
                    options: [
                        __("matchform.start_first_leg_option1"),
                        __("matchform.start_first_leg_option2"),
                        __("matchform.start_first_leg_option3"),
                        __("matchform.start_first_leg_option4"),
                    ],
                    selected: __("matchform.start_first_leg_option1"),
                    description: __("matchform.start_first_leg_description"),
                    denyChange: false,
                },
                {
                    id: "starting_otherlegs",
                    name: __("matchform.other_legs"),
                    class: "col-xl-6 col-12 bg-darker",
                    options: [
                        __("matchform.other_legs_option1"),
                        __("matchform.other_legs_option2"),
                        __("matchform.other_legs_option3"),
                    ],
                    selected: __("matchform.other_legs_option1"),
                    denyChange: false,
                },
                {
                    id: "ranked",
                    name: "Rangliste",
                    options: [__("matchform.yes"), __("matchform.no")],
                    selected: __("matchform.no"),
                    description: __("matchform.ranked_description"),
                    denyChange: false,
                    onlineOption: true,
                },
                {
                    id: "liga",
                    name: "Ligaspiel",
                    class: "col-12 bg-darker",
                    options: [__("matchform.yes"), __("matchform.no")],
                    selected: __("matchform.no"),
                    description: __("matchform.league_description"),
                    denyChange: false,
                    onlineOption: true,
                },
                {
                    id: "boardtype",
                    name: __("matchform.boardtype"),
                    class: "col-xl-6 col-12",
                    options: [
                        __("matchform.boardtype_option1"),
                        __("matchform.boardtype_option2"),
                        __("matchform.boardtype_option3"),
                    ],
                    selected: __("matchform.boardtype_option1"),
                    description: __("matchform.boardtype_description"),
                    denyChange: false,
                    onlineOption: true,
                },
                {
                    id: "cpu_strength",
                    name: __("matchform.cpu_strength"),
                    class: "col-xl-6 col-12",
                    range: [1, 10],
                    selected: 4,
                    denyChange: false,
                },
                {
                    id: "cpu_time",
                    name: __("matchform.cpu_timer"),
                    range: [1, 10],
                    selected: 3,
                    class: "col-xl-6 col-12",
                    denyChange: false,
                },
                {
                    id: "cameras",
                    name: __("matchform.cameras"),
                    class: "col-xl-6 col-12 bg-darker",
                    options: [
                        __("matchform.cameras_option1"),
                        __("matchform.cameras_option2"),
                        __("matchform.cameras_option3"),
                    ],
                    selected: __("matchform.cameras_option1"),
                    description: __("matchform.cameras_description"),
                    denyChange: false,
                    onlineOption: true,
                },
                {
                    id: "microphone",
                    name: __("matchform.audiochat"),
                    class: "col-xl-6 col-12 bg-darker",
                    options: [
                        __("matchform.yes"),
                        __("matchform.no"),
                        __("matchform.audiochat_option3"),
                    ],
                    selected: __("matchform.audiochat_option3"),
                    description: __("matchform.audiochat_description"),
                    denyChange: false,
                    onlineOption: true,
                },
            ],
            automatOptions: [
                {
                    id: "automat_players",
                    name: __("matchform.automat_players"),
                    class: "col-xl-6 col-12 bg-darker",
                    options: [
                        1,
                        2,
                        3,
                        4,
                    ],
                    selected: 1,
                    description: __("matchform.automat_players_description"),
                    denyChange: false,
                    onlineOption: false,
                },
                {
                    id: "automat_cpu_players",
                    name: __("matchform.automat_cpu_players"),
                    class: "col-xl-6 col-12 bg-darker",
                    options: [
                        0,
                        1,
                        2,
                        3
                    ],
                    selected: 0,
                    description: __("matchform.automat_cpu_players_description"),
                    denyChange: false,
                    onlineOption: false,
                }
            ],
            selectedMatchType: {},
            setmeeting: "false",
            date: new Date(),
            timezone: "Europe/Amsterdam",
            leaguegame: false,
            leagues: [],
            league: null,
            league_opponents: [],
            league_opponent: null,
            step: 1,
            step2selectedOptions: [],
            showTip: [],
            showOnlineOptions: false,
        };
    },
    mounted() {
        console.log(this.appmode);
        this.selectedMatchType = this.matchtypes[0];

        this.globalOptions.forEach(option => {
            this.showTip[option.id] = false;
        });

        //online mode, filter local matchtypes
        if (location.host.indexOf("online") != -1) {
            let tempTypes = [];
            this.matchtypes.forEach(mtype => {
                if (!mtype.local) tempTypes.push(mtype)
            });
            this.matchtypes = tempTypes;
        }
    },
    methods: {
        matchtypeSelect: function (id) {
            this.matchtypes.forEach((t) => {
                if (t.id == id) {
                    this.selectedMatchType = t;
                }
            });
        },
        optionSelect(name, option) {
            this.selectedMatchType.options.forEach((element) => {
                if (element.name == name) {
                    element.selected = option;
                }
            });
        },
        optionSelectGlobal(name, option) {
            this.globalOptions.forEach((element) => {
                if (element.name == name) {
                    element.selected = option;
                    if (element.name == "Ligaspiel" && option == "Ja")
                        this.showLigaspiel();
                    if (element.name == "Ligaspiel" && option == "Nein")
                        this.hideLigaspiel();
                }
            });
        },
        optionSelectAutomat(name, option) {
            this.automatOptions.forEach((element) => {
                if (element.name == name) {
                    element.selected = option;
                }
            });
        },
        optionsRangeSelect(name, modifier) {
            this.globalOptions.forEach((element) => {
                if (element.name == name) {
                    element.selected = parseInt(element.selected);
                    element.selected += modifier;
                    if (element.selected < element.range[0])
                        element.selected = element.range[0];
                    if (element.selected > element.range[1])
                        element.selected = element.range[1];
                }
            });

            this.selectedMatchType.options.forEach((element) => {
                if (element.name == name) {
                    element.selected = parseInt(element.selected);
                    element.selected += modifier;
                    if (element.selected < element.range[0])
                        element.selected = element.range[0];
                    if (element.selected > element.range[1])
                        element.selected = element.range[1];
                }
            });
        },
        parseOptions() {
            var returnArray = [];
            this.selectedMatchType.options.forEach((element) => {
                returnArray.push({
                    name: element.id ? element.id : element.name,
                    label: element.name,
                    value: element.selected,
                });
            });
            return returnArray;
        },
        parseOverrideOptions() {
            var returnArray = this.globalOptions;
            if (this.selectedMatchType.overrideGlobalOptions) {
                this.selectedMatchType.overrideGlobalOptions.forEach((element) => {
                    returnArray.forEach((element2) => {
                        if (element2.id == element.key) {
                            if (typeof element.value === 'string')
                                element2.selected = __(element.value);
                            else
                                element2.selected = element.value;
                            element2.denyChange = true;
                        }
                    });
                });
            }
            return returnArray;
        },
        selectedGlobalOption(id) {
            var chosen = null;
            this.globalOptions.forEach((element) => {
                if (element.id == id) {
                    if (element.selected == "Ja" || element.selected == "yes") {
                        chosen = true;
                    } else if (element.selected == "Nein" || element.selected == "no") {
                        chosen = false;
                    } else {
                        chosen = element.selected;
                    }
                }
            });
            return chosen;
        },
        selectedAutomatOption(id) {
            var chosen = null;
            this.automatOptions.forEach((element) => {
                if (element.id == id) {
                    if (element.selected == "Ja" || element.selected == "yes") {
                        chosen = true;
                    } else if (element.selected == "Nein" || element.selected == "no") {
                        chosen = false;
                    } else {
                        chosen = element.selected;
                    }
                }
            });
            return chosen;
        },
        parseStartingOptions() {
            var data = [];
            data.push({
                name: "starting_firstleg",
                value: this.selectedGlobalOption("starting_firstleg"),
            });
            data.push({
                name: "starting_otherlegs",
                value: this.selectedGlobalOption("starting_otherlegs"),
            });
            data.push({
                name: "cpu_time",
                value: this.selectedGlobalOption("cpu_time"),
            });
            data.push({
                name: "cpu_strength",
                value: this.selectedGlobalOption("cpu_strength"),
            });

            //add a random number to determine the starter if random start is selected
            if (this.selectedGlobalOption("starting_firstleg") == "Zufall") {
                data.push({ name: "starting_number", value: Math.random() + 1 });
            }
            return data;
        },
        parseAutomatOptions() {
            var data = [];
            data.push({
                name: "automat_players",
                value: this.selectedAutomatOption("automat_players"),
            });
            data.push({
                name: "automat_cpu_players",
                value: this.selectedAutomatOption("automat_cpu_players"),
            });
            return data;
        },
        submit() {
            var boardtype = 0;
            if (this.selectedGlobalOption("boardtype") == "Alle") boardtype = 0;
            if (this.selectedGlobalOption("boardtype") == "Steeldart") boardtype = 1;
            if (this.selectedGlobalOption("boardtype") == "E-Dart") boardtype = 2;

            var cameras = 0;
            if (this.selectedGlobalOption("cameras") == "Keine") cameras = 0;
            if (this.selectedGlobalOption("cameras") == "Board") cameras = 1;
            if (this.selectedGlobalOption("cameras") == "Board und Spieler")
                cameras = 2;

            var microphone = 0;
            if (this.selectedGlobalOption("microphone")) microphone = 1;
            else if (!this.selectedGlobalOption("microphone")) microphone = 0;
            else if (this.selectedGlobalOption("microphone") == "Egal")
                microphone = 2;
            var data = {
                matchtype_id: this.selectedMatchType.id,
                legs: this.selectedGlobalOption("legs"),
                sets: this.selectedGlobalOption("sets"),
                ranked: this.selectedGlobalOption("ranked"),
                boardtype: boardtype,
                options: this.parseOptions(),
                starting_options: this.parseStartingOptions(),
                automat_options: this.parseAutomatOptions(),
                cameras: cameras,
                microphone: microphone,
            };
            if (this.player2) {
                data.user2_id = this.player2.id;
            }
            if (this.setmeeting == "true") {
                data.scheduled_date = this.moment(this.date).format(
                    "YYYY-MM-DD HH:mm:ss"
                );
            }

            if (this.league_opponent) {
                data.user2_id = this.league_opponent;
                data.external_league_id = this.league;
            }
            axios
                .post("/matchrequests", data)
                .then((e) => {
                    if (this.appmode == 'automat') {
                        toastSuccess("Game On!");
                        window.location.href = "/games/" + e.data.id;
                    } else {
                        toastSuccess("Spielanfrage erstellt");
                        window.location.href = "/matchrequests/" + e.data.id;
                    }
                })
                .catch((e) => {
                    toastError("Fehler bei Erstellung der Anfrage");
                });
        },
        showLigaspiel() {
            axios.get("/external_leagues/get_leagues").then((response) => {
                this.leagues = response.data;
                this.leaguegame = true;
            });
        },
        onSelectLeague() {
            axios
                .get("/external_leagues/" + this.league + "/get_opponents")
                .then((response) => {
                    this.league_opponents = response.data;
                });
        },
        hideLigaspiel() {
            this.leaguegame = false;
            this.league = null;
            this.league_opponent = null;
        },
        nextStep() {
            this.step += 1;
            if (this.selectedMatchType.options.length == 0) this.step += 1; //skip second step if no options
            if (this.step == 3) {
                this.step2selectedOptions = this.parseOptions();
                this.globalOptions = this.parseOverrideOptions();
            }
            if (this.step > 3) this.step = 3;
        },
        previousStep() {
            this.step -= 1;
            if (this.selectedMatchType.options.length == 0) this.step -= 1; //skip second step if no options
            if (this.step <= 0) this.step = 1;
        },
        gotoStep(number) {
            this.step = number;
        },
        toggleShowTip(id) {
            this.showTip[id] = !this.showTip[id];
            this.$forceUpdate();
        },
        toggleShowOnlineOptions() {
            this.showOnlineOptions = !this.showOnlineOptions;
        }

    },
};
</script>

<style scoped>

</style>
